import { useCallback, useMemo } from 'react'
import { ModalCreateEditStructureLayout } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import InputColor from '../../../../../../../../forms/Input/InputColor'
import TwinForm from '../../../../../../../../forms/TwinForm'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { WCalTurnConfigData } from '..'
import { getAllWorkingCenters } from '../../../../../../../../utils/reducers/getters'

type ModalConfigTurnWCColorsProps = ModalEditComponentProps & ModalTaskCalendarColorPickerLogicProps & {
    loading: boolean
    onSave: () => false
    selectedData: WCalTurnConfigData
}

const ModalConfigTurnWCColors: React.FC<ModalConfigTurnWCColorsProps> = ({ selectedData, setSelectedData, loading, onSave }) => {
    const { t } = useTwinTranslation()
    const { handleOnChange } = useModalTaskCalendarColorPickerLogic({ setSelectedData })
    const memorizedWorkingCenters = useMemo(() => getAllWorkingCenters(), [])
    const renderThisWorkingCenters: JSX.Element[] = []
    if (memorizedWorkingCenters) {
        for (const key in memorizedWorkingCenters) {
            const workingCenter = memorizedWorkingCenters[key]
            renderThisWorkingCenters.push(<WCalTurnColorConfig key={key} name={workingCenter.name} onChange={(value) => handleOnChange(value, workingCenter.id)} color={selectedData?.colors?.[workingCenter.id] || '#E0FCF2'} />)
        }
    }

    return (
        <TwinForm beforeSubmitHandler={() => {
            onSave()
            return false
        }} className='flex flex-col flex-auto'>
            <ModalCreateEditStructureLayout loading={loading} translations={{
                title: t('assignColors', 'Definir colores'),
                button: t('save', 'Guardar')
            }} haveButtonPermissions={true} className='flex-auto flex flex-col h-1'>
                <div className='flex flex-col mt-20 overflow-y-auto flex-auto'>
                    <h3><TwinTrans transKey='workingCenters'>Centros de trabajo</TwinTrans></h3>
                    {renderThisWorkingCenters}
                </div>
            </ModalCreateEditStructureLayout>
        </TwinForm>
    )
}

interface ModalTaskCalendarColorPickerLogicProps {
    setSelectedData: React.Dispatch<React.SetStateAction<WCalTurnConfigData>>
}

const useModalTaskCalendarColorPickerLogic = ({ setSelectedData }: ModalTaskCalendarColorPickerLogicProps) => {
    const handleOnChange = useCallback((value: string, id: number) => {
        setSelectedData((old) => {
            if (!old) {
                return old
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            if (!copyOld['colors']) {
                copyOld['colors'] = {}
            }
            copyOld['colors'][id] = value
            return { ...copyOld }
        })
    }, [setSelectedData])

    return { handleOnChange }
}


interface EmployeesColorConfigProps {
    name: string
    color: string
    onChange: (value: string) => void
}

const WCalTurnColorConfig: React.FC<EmployeesColorConfigProps> = ({ name, color, onChange }) => {
    return (
        <div className='flex justify-between items-center mt-10'>
            <span>{name}</span>
            <InputColor
                onChange={(value) => onChange(value)}
                className='taskcalendar_input_color'
                value={color}
                colors={['#E2F3FF', '#E0FCF2', '#F3FCE0', '#E0ECFC', '#E3E0FC', '#F5E0FC', '#FCE0F5', '#FCF5E0', '#E0FCE3', '#E0EFFC']}
            />
        </div>
    )
}

export default ModalConfigTurnWCColors